import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAuditEntry } from '../interfaces/audit/IAudit';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private readonly http = inject(HttpClient);

  private readonly auditApi = environment.apiUrl + 'Audit/';

  public getAuditHistory(entityName: string, entityId: string): Observable<IAuditEntry[]> {
    return this.http.get<IAuditEntry[]>(`${this.auditApi}${entityName}/${entityId}`);
  }

  public getRelatedAuditHistory(entityType: string, relation: string, value: string): Observable<Record<string, IAuditEntry[]>> {
    return this.http.get<Record<string, IAuditEntry[]>>(`${this.auditApi}related`, {
      params: { entityType, relation, value },
    });
  }
}
